<template>
    <div class="nav-container">
        <img src="@/assets/images/Group1.png" alt="" width="112px">
        <div class="nav-container-r">
            <a href="javascript:;" class="link">About</a>
            <a href="https://www.autoinfo.org.cn/" class="link" target="_blank">Chinese</a>
            <div class="user-info" v-if="show">
                <el-dropdown @command="handleCommand">
                    <div class="el-dropdown-link">
                        <img src="@/assets/images/20141229151653_HiM8B.jpeg" alt="" />
                        <span>{{ userName }}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        userName:{
            type:String,
            default:""
        }
    },
    data() {
        return {
            show: true,
        };
    },
    created() {},
    methods: {
        handleCommand(command) {
            this.$emit("command", command);
        },
        handleClick() {
            this.$emit("click");
        },
    },
};
</script>
<style lang="less" scoped>
.nav-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    padding: 0 33px;
    &-r {
        display: flex;
        align-items: center;
        .link {
            display: block;
            margin-right: 34px;
            font-weight: 500;
            color: #828282;
            text-decoration: none;
        }
        .user-info {
            font-weight: bold;
            color: #333;
            height: 36px;
            img {
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
            span {
                padding-left: 8px;
            }
        }
        .login {
            width: 106px;
            border: 2px solid #0d57bc;
            margin-left: 37px;
            font-weight: bold;
        }
        .el-dropdown-link {
            display: flex;
            align-items: center;
        }
    }
}
</style>
